
    export default {
        name: 'SectionHowItWorks',

        props: {
            animate: {
                type: Boolean,
                defaultL: false,
            },
        },

        watch: {
            animate(isAnimate) {
                if (isAnimate) {
                    this.animation();
                }
            },
        },

        methods: {
            ctaClick($e) {
                this.$emit('ctaClick', $e);
            },
            async animation() {
                const animates = [
                    {
                        iconRef: 'animateIcon1',
                        textRef: 'animateText1',
                        lineRef: 'animateLine1',
                    },
                    {
                        iconRef: 'animateIcon2',
                        textRef: 'animateText2',
                        lineRef: 'animateLine2',
                    },
                    {
                        iconRef: 'animateIcon3',
                        textRef: 'animateText3',
                    },
                ];

                const vm = this;
                for (const i of animates) {
                    await this.$velocity([
                        this.$refs[i.iconRef],
                        this.$refs[i.textRef],
                    ], {
                        opacity: 1,
                    }, {
                        easing: 'easeInOutQuart',
                        duration: 400,
                        complete() {
                            if (i.lineRef) {
                                vm.$velocity(vm.$refs[i.lineRef], { opacity: 0.15 }, {
                                    easing: 'easeInOutQuart',
                                    duration: 200,
                                });
                            }
                        },
                    });
                }
            },
        },
    };
